import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { SelectionPlugin } from '@atlaskit/editor-plugin-selection';
import { LoadableLazy, type LoadableType } from '@confluence/loadable';

export const SmartButtonConfigPanel: LoadableType<{
	localId: string;
	closeSelf: () => void;
	editorApi: PublicPluginAPI<[SelectionPlugin]> | undefined;
	isTemplateEditor?: boolean;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartButtonConfigPanel" */ '../src/smart-buttons/edit/SmartButtonConfigPanel/SmartButtonConfigPanel.tsx'
			)
		).SmartButtonConfigPanel,
});
